export default __webpack_public_path__ + "static/media/noun_Battery_-1.6cf0763f.svg";